import { Injectable } from '@angular/core';

import { AppNotificationsService } from '@deltager/organizers/admin/core/services/app-notifications.service';
import { AppNotificationType } from '@deltager/organizers/admin/shared/models/AppNotificationType';
import { SpinnerOverlayService } from '@deltager/organizers/admin/shared/spinner-overlay/spinner-overlay.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EventSetupUIActionTypes, ShowNotificationAction } from './event-setup.ui.actions';
import { tap } from 'rxjs';

@Injectable()
export class EventSetupUIEffects {
  constructor(
    private actions$: Actions,
    private spinner: SpinnerOverlayService,
    private appNotificationService: AppNotificationsService,
  ) {}

  showNotification$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(EventSetupUIActionTypes.ShowNotification),
        tap((action: ShowNotificationAction) => {
          this.spinner.hide();

          const notificationMessage = action.payload.message;
          const notificationType = action.payload.notificationType;

          this.appNotificationService.sendNotification({
            type: notificationType ? notificationType : AppNotificationType.SUCCESS,
            message: notificationMessage,
          });
        }),
      );
    },
    { dispatch: false },
  );
}
